import { createSlice } from '@reduxjs/toolkit'

export const userInfoSlice = createSlice({
	name: 'userInfo',
	initialState: {
		info: {
			roles: [],
			username: '',
			id: '',
			email: '',
		},
	},
	reducers: {
		setUserInfo: (state, actions) => {
			state.info = actions.payload
		},
		removeUserInfo: (state) => {
			state.info = {
				roles: [],
				username: '',
				id: '',
				email: '',
			}
		},
	},
})

export const { setUserInfo, removeUserInfo } = userInfoSlice.actions
export default userInfoSlice.reducer
export const selectuserInfo = (state: any) => state.userInfo.info
